<script>
import { Base as BaseApi } from 'firepuma-vue-axios-vuex-extensions/axios-utils/apiBase';

export default {
  props: {
    method: { type: String, required: true },
    url: { type: String, required: true },
    payload: { type: Object, default: () => ({}) },
    responseType: { type: String, default: () => undefined },

    showBusy: { type: Boolean, default: () => true },
    showError: { type: Boolean, default: () => true },
  },

  data: () => ({
    result: undefined,
    busy: false,
    error: undefined,
    responseHeaders: undefined,
  }),

  async created() {
    this.error = undefined;
    this.busy = true;
    try {
      let base = new BaseApi();
      let api = base.api();

      let result = await api.request({ method: this.method, url: this.url, data: this.payload, responseType: this.responseType });
      this.responseHeaders = result.headers;
      result = await base.handleResponse(result);

      this.$emit('loaded', result);
      this.result = result;
    } catch (err) {
      this.error = String(err);
    } finally {
      this.busy = false;
    }
  },
}
</script>

<template>
  <div>
    <b-card v-if="busy && showBusy" class="my-3"> <i class="fa fa-spinner fa-spin"></i> </b-card>
    <b-alert v-if="error && showError" variant="danger" show dismissible class="mb-3">{{error}}</b-alert>

    <slot v-if="result" :busy="busy" :error="error" :result="result" :responseHeaders="responseHeaders"></slot>
  </div>
</template>



// WEBPACK FOOTER //
// src/AxiosApiLoader.vue